import { Button } from "@/components/ui/button";

interface GroupingHierarchyStageProps {
  mode: "editable" | "readonly";
  blockingIssueCount?: number;
  isLoading?: boolean;
  onConfirm?: () => void;
}

export const GroupingHierarchyStage = ({
  mode,
  blockingIssueCount = 0,
  isLoading = false,
  onConfirm,
}: GroupingHierarchyStageProps) =>
  mode === "editable" && onConfirm ? (
    <div className="flex justify-end">
      <Button disabled={blockingIssueCount > 0 || isLoading} onClick={onConfirm}>
        {isLoading ? "Confirming…" : "Confirm grouping"}
      </Button>
    </div>
  ) : null;
